<div class="row" *ngIf="title !== undefined">
  <div class="col-4"><label>{{title}}</label></div>
  <div class="col-8">
    <div class="form-group">

      <textarea
        class="form-control"
        rows="5"

        [placeholder]="title"
        [(ngModel)]="value"
        (input)="updateValue($any($event.target).value)">
      </textarea>
    </div>
  </div>
</div>
<div class="form-group" *ngIf="title === undefined">
  <textarea
    class="form-control"
    rows="5"
    [(ngModel)]="value"
    (input)="updateValue($any($event.target).value)">
  </textarea>
</div>
